export const errDictionaty = {
  EMAIL_NOT_FOUND: 'No se encontró el email asociado a este RUT',
  MFA_SERVICE_NOT_CONFIGURED:
    'El servicio de MFA no está configurado, por favor contacta a soporte',
}
